import React, { useContext, useEffect, useRef, useState } from "react";
// import "../../styles/component/popup/CustomizeTabsModal.css";

// import Style from "./style.module.css";

import { FieldArray, useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  CalendarIcon,
  File,
  Minus,
  PlusIcon,
  Trash2,
  UploadCloud,
} from "lucide-react";
import { Link } from "react-router";
import Select from "react-select";
import { useApiCall } from "../../custom-hooks/api-call";
import { GlobalContext } from "../../../context/Context";
import Tooltip from "../../ui/tooltip";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
  SelectSearch,
} from "../../form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddLeadModal = ({
  Style,
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  BrandList = [],
  PackageList = [],
  DealStages = [],
  Countries = [],
  CustomerData = {},
  UsersList = [],
}) => {
  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [showDealFields, setShowDealFields] = useState(false);
  const [showAdditionalFiels, setShowAdditionalFiels] = useState(false);

  const metas = Object.fromEntries(
    CustomerData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? []
  );
  const initialMainId = metas?.main_product ? Number(metas.main_product) : null;
  const initialSubId =
    CustomerData?.service || CustomerData?.source || ""
      ? Number(CustomerData?.service || CustomerData?.source || "")
      : null;
  const initialPackageId = CustomerData?.deal_package
    ? Number(metas.deal_package)
    : null;

  let { state, dispatch } = useContext(GlobalContext);

  const userOptions = UsersList.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const countryOptions = Countries?.map((country) => ({
    value: country.country_code,
    label: country.country_name,
  }));

  const brandOptions = BrandList?.map((mp) => ({
    value: mp.brandsid,
    label: mp.brandname,
  }));

  // old code

  // const mainProductOptions = ProductList?.map((mp) => ({
  //   value: mp.id,
  //   label: mp.products,
  // }));

  // const subProductOptions = SubProductList?.map((mp) => ({
  //   value: mp.id,
  //   label: mp.products,
  // }));

  // const packageOptions = PackageList?.map((mp) => ({
  //   value: mp.packageid,
  //   label: mp.packagename,
  // }));

  const apiCall = useApiCall();

  // const [imageError, setImageError] = useState(false);
  const [packageFeatures, setPackageFeatures] = useState("");
  const [brandUrl, setBrandUrl] = useState("");
  // const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

  const handlePackage = (selectId) => {
    const selectedPackageId = selectId;
    // console.log(selectedPackageId);

    // formik.setFieldValue("deal_package", selectedPackageId);

    // Find selected package
    const selected = PackageList?.find(
      (pkg) => pkg?.packageid == selectedPackageId
    );

    // console.log("selected", selected);

    // Set selected package features
    if (selected) {
      setPackageFeatures(stripHtml(selected?.features || ""));
    } else {
      setPackageFeatures("");
    }
  };
  const handleLeadSource = (selectId) => {
    const selectedBrandId = selectId;
    // console.log(selectedBrandId);

    // formik.setFieldValue("deal_package", selectedPackageId);

    // Find selected package
    const selected = BrandList?.find((pkg) => pkg?.brandsid == selectedBrandId);

    // console.log("selected", selected);

    // Set selected package features
    if (selected) {
      setBrandUrl(selected?.brandurl || "");
    } else {
      setBrandUrl("");
    }
  };

  const AddField = () => {
    const newFields = [
      ...formik.values.extra_meta,
      { meta_key: "", meta_value: "" },
    ];
    formik.setFieldValue("extra_meta", newFields);
  };

  const DeleteField = (index) => {
    const newFields = formik.values.extra_meta.filter((_, i) => i !== index);
    formik.setFieldValue("extra_meta", newFields);
  };

  useEffect(() => {
    const metaArray = Array.isArray(CustomerData?.extra_meta)
      ? CustomerData.extra_meta
      : Array.isArray(CustomerData?.meta)
      ? CustomerData.meta
      : Array.isArray(CustomerData?.metas)
      ? CustomerData.metas
      : [];

    const mainProductMeta = metaArray.find(
      (item) => item.meta_key === "main_product"
    );

    const IndustryMeta = metaArray.find((item) => item.meta_key === "industry");

    if (CustomerData?.userid || CustomerData?.leadid) {
      // console.log("***CustomerData****", CustomerData);

      //  console.log("Edit id" , CustomerData.)

      formik.setFieldValue("customerFullName", CustomerData?.name || "");
      formik.setFieldValue("customerEmailAddress", CustomerData?.email || "");
      formik.setFieldValue("phone", CustomerData?.phone || "");
      formik.setFieldValue("country", CustomerData?.country || "");
      formik.setFieldValue(
        "product",
        CustomerData?.service || CustomerData?.source || ""
      );
      formik.setFieldValue("brandid", CustomerData?.brand_id || "");
      formik.setFieldValue("message", CustomerData?.message || "");

      formik.setFieldValue(
        "industry",
        IndustryMeta?.meta_value ? IndustryMeta.meta_value : ""
      );

      formik.setFieldValue(
        "lead_assigned",
        Array.isArray(CustomerData?.assigned)
          ? CustomerData.assigned.map((user) => user.userid)
          : Array.isArray(CustomerData?.assigned_users)
          ? CustomerData.assigned_users.map((user) => user.userid)
          : Array.isArray(CustomerData?.assigned_user_details)
          ? CustomerData.assigned_user_details.map((user) => user.userid)
          : []
      );

      console.log("lead assigned →", formik.values.lead_assigned);

      formik.setFieldValue("address", CustomerData?.address || "");
      formik.setFieldValue("city", CustomerData?.city || "");
      formik.setFieldValue("state", CustomerData?.state || "");
      formik.setFieldValue("company_name", CustomerData?.companyname || "");
      formik.setFieldValue(
        "main_product",
        mainProductMeta?.meta_value ? Number(mainProductMeta.meta_value) : ""
      );

      if (CustomerData?.brand_id) {
        handleLeadSource(CustomerData?.brand_id);
      }
    }
  }, [CustomerData]);

  const validationSchema = yup.object({
    customerFullName: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    customerEmailAddress: yup
      .string("This Field is Required")
      .required("This Field is Required")
      .email("Enter a Valid Email"),
    phone: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    country: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    main_product: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    product: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    brandid: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    message: CustomerData?.userid
      ? null
      : yup.string("This Field is Required").required("This Field is Required"),
    lead_assigned: yup
      .array()
      .of(yup.string())
      .min(1, "This Field is Required")
      .required("This Field is Required"),

    industry: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      customerFullName: "",
      customerEmailAddress: "",
      phone: "",
      country: "",
      product: "",
      brandid: "",
      leadsource: "",
      message: "",
      lead_assigned: "",
      industry: "",
      main_product: initialMainId || "",

      //  Convert lead to deal
      name: "",
      deal_package: "",
      estimated_payment_date: "",
      dealamount: "",
      dealstage: DealStages[0]?.name,
      dealprobability: "",
      description: "",

      // Extra Optional Fields

      matchtype: "",
      device: "",
      keyword: "",
      utm_term: "",
      gclid: "",
      msclkid: "",
      ip: "",
      address: "",
      address_line_2: "",
      city: "",
      state: "",
      zip: "",
      country: "",

      company_name: "",
      extra_meta: (Array.isArray(CustomerData?.extra_meta)
        ? CustomerData.extra_meta
        : Array.isArray(CustomerData?.meta)
        ? CustomerData.meta
        : Array.isArray(CustomerData?.metas)
        ? CustomerData.metas
        : []
      ).map((item) => ({
        meta_key: item.meta_key,
        meta_value: item.meta_value,
      })),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log("values", values);

      // let extra_meta = [];

      // for (let i = 0; i < AddMore?.length; i++) {
      //   extra_meta.push({
      //     meta_key: values[`dynamicKey${i + 1}`],
      //     meta_value: values[`dynamicValue${i + 1}`],
      //   });
      // }

      // console.log("ExtraMeta", extra_meta);

      let extra_meta = values.extra_meta.map((item) => ({
        key: item.meta_key,
        value: item.meta_value,
      }));

      if (packageFeatures) {
        extra_meta.push({
          key: "features",
          value: packageFeatures || "",
        });
      }

      extra_meta.push({
        key: "main_product",
        value: values.main_product,
      });

      let nonRequiredField = {};

      if (values.name) {
        nonRequiredField = { ...nonRequiredField, name: values.name };
      }
      if (values.deal_package) {
        nonRequiredField = {
          ...nonRequiredField,
          deal_package: values.deal_package,
        };
      }
      if (values.estimated_payment_date) {
        nonRequiredField = {
          ...nonRequiredField,
          estimated_payment_date: values.estimated_payment_date,
        };
      }
      if (values.dealamount) {
        nonRequiredField = {
          ...nonRequiredField,
          dealamount: values.dealamount,
        };
      }
      if (values.dealstage) {
        nonRequiredField = { ...nonRequiredField, dealstage: values.dealstage };
      }
      if (values.dealprobability) {
        nonRequiredField = {
          ...nonRequiredField,
          dealprobability: values.dealprobability,
        };
      }
      if (values.description) {
        nonRequiredField = {
          ...nonRequiredField,
          description: values.description,
        };
      }

      let data;

      if (CustomerData?.userid || CustomerData?.leadid) {
        CustomerData?.userid
          ? (data = {
              userid: CustomerData?.userid,
              customerFullName: values.customerFullName,
              customerEmailAddress: values.customerEmailAddress,
              phone: values.phone,
              country: values.country,
              product: values.product,
              brandid: Number(values.brandid),
              lead_assigned: values.lead_assigned.map((id) => Number(id)),
              leadsource: brandUrl,
              address: values.address,
              city: values.city,
              state: values.state,
              company_name: values.company_name,
              extra_meta: extra_meta,
            })
          : (data = {
              leadid: CustomerData.leadid,
              customerFullName: values.customerFullName,
              customerEmailAddress: values.customerEmailAddress,
              phone: values.phone,
              country: values.country,
              product: values.product,
              brandid: Number(values.brandid),
              message: values.message,
              lead_assigned: values.lead_assigned.map((id) => Number(id)),
              leadsource: brandUrl,
              address: values.address,
              city: values.city,
              state: values.state,
              company_name: values.company_name,
              extra_meta: extra_meta,
            });
      } else {
        data = {
          ...nonRequiredField,
          customerFullName: values.customerFullName,
          customerEmailAddress: values.customerEmailAddress,
          phone: values.phone,
          country: values.country,
          leadsource: brandUrl,
          product: Number(values.product),
          brandid: Number(values.brandid),
          message: values.message,
          lead_assigned: values.lead_assigned.map((id) => Number(id)),

          //  Convert lead to deal
          // name: values.name,
          // // product: values.product,
          // deal_package: Number(values.deal_package),
          // estimated_payment_date: values.estimated_payment_date,
          // dealamount: values.dealamount,
          // dealstage: values.dealstage,
          // dealprobability: values.dealprobability,
          // description: values.description,

          matchtype: values.matchtype,
          device: values.device,
          keyword: values.keyword,
          utm_term: values.utm_term,
          gclid: values.gclid,
          msclkid: values.msclkid,
          ip: values.ip,
          address: values.address,
          address_line_2: values.address_line_2,
          city: values.city,
          state: values.state,
          zip: values.zip,
          country: values.country,
          industry: values.industry,
          company_name: values.company_name,
          extra_meta: extra_meta,
        };
      }

      // console.log("Final Data", data);
      // console.log("Brand Url", brandUrl);

      try {
        let apiRes = await apiCall({
          method: "post",
          url:
            CustomerData?.userid || CustomerData?.leadid
              ? "leads/edit-custom-lead "
              : "leads/add-custom-lead",
          data: data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
        onClose();
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  const [TotalStages, setTotalStages] = useState(5);
  const [CurrentStage, setCurrentStage] = useState(1);

  useEffect(() => {
    let totalStages = DealStages?.length;
    setTotalStages(totalStages);
  }, []);

  const handleStageClick = (StageId) => {
    setCurrentStage(StageId);

    const selectedValue = DealStages.find((stage) => stage.id == StageId)?.name;
    formik.setFieldValue("dealstage", selectedValue || "");
  };

  const primaryFields = [
    "customerFullName",
    "customerEmailAddress",
    "phone",
    "country",
    "product",
    "brandid",
    "message",
    "lead_assigned",
    "address",
    "city",
    "state",
    "company_name",
    "name",
    "email",
  ];

  // useEffect(() => {
  //   fetchSubProducts(formik.values.main_product); // sub products fetch
  // }, [formik.values.main_product]);

  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        if (initialSubId) {
          loadPackages(initialSubId);
        }
      });
    } else if (initialSubId) {
      loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const loadPackages = async (subProductId) => {
    if (!subProductId) {
      setPackages([]);
      return;
    }
    setLoadingPackages(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (err) {
      console.warn("Error loading packages:", err);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
  };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    const id = option?.value || "";

    formik.setFieldValue("main_product", id);

    formik.setFieldValue("product", "");
    // formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    setSubProducts([]);
    setPackages([]);

    if (id) {
      await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option?.value || "";
    formik.setFieldValue("product", id);

    // formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    setPackages([]);

    if (id) {
      await loadPackages(id);
    }
  };

  const handlePackageSelect = (option) => {
    const id = option?.value || "";
    const pkg = packages.find((p) => Number(p.packageid) === Number(id));
    // formik.setFieldValue("deal_package_id", id);
    formik.setFieldValue("deal_package", id || "");

    // set features from package if exists
    if (pkg?.features) {
      formik.setFieldValue("features", stripHtml(pkg.features || ""));
      setPackageFeatures(pkg?.features || "");
    } else {
      formik.setFieldValue("features", "");
      setPackageFeatures("");
    }
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid)
      ) === i
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));

  // console.log("opt", subOptions);
  // const packageOptions = [
  //   ...packagesUnique.map((pk) => ({
  //     value: pk.packageid,
  //     label: pk.packagename || `#${pk.packageid}`,
  //   })),
  //   { value: 3, label: "Other" },
  // ];
  const packageOptions =
    packagesUnique.length > 0
      ? [
          ...packagesUnique.map((pk) => ({
            value: pk.packageid,
            label: pk.packagename || `#${pk.packageid}`,
          })),
          { value: 3, label: "Other" },
        ]
      : [];

  const editMainId = metas?.main_product ? Number(metas.main_product) : null;
  const editSubId = CustomerData?.service
    ? Number(CustomerData.service)
    : CustomerData?.source
    ? Number(CustomerData.source)
    : null;
  const editPackageId = CustomerData?.deal_package
    ? Number(CustomerData.deal_package)
    : null;

  useEffect(() => {
    let mounted = true;
    const runPrefill = async () => {
      try {
        if (editMainId) {
          formik.setFieldValue("main_product", editMainId, false);

          await loadSubProducts(editMainId);
        }

        if (editSubId) {
          const existsInSub = subProducts.some(
            (sp) =>
              Number(sp.id ?? sp.subproductid ?? sp.productid) ===
              Number(editSubId)
          );
          if (!existsInSub) {
            setSubProducts((prev) => {
              const merged = [
                ...prev,
                {
                  id: editSubId,
                  products:
                    CustomerData?.product_name || `Product #${editSubId}`,
                },
              ];

              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) =>
                      Number(t.id ?? t.subproductid ?? t.productid) ===
                      Number(v.id ?? v.subproductid ?? v.productid)
                  ) === i
              );
              return unique;
            });
          }

          formik.setFieldValue("product", editSubId, false);

          await loadPackages(editSubId);

          if (editPackageId) {
            const existsPkg = packages.some(
              (pk) => Number(pk.packageid) === Number(editPackageId)
            );
            if (!existsPkg) {
              setPackages((prev) => {
                const merged = [
                  ...prev,
                  {
                    packageid: editPackageId,
                    packagename: metas?.packagename,
                  },
                ];

                const unique = merged.filter(
                  (v, i, a) =>
                    a.findIndex(
                      (t) => Number(t.packageid) === Number(v.packageid)
                    ) === i
                );
                return unique;
              });
            }

            // formik.setFieldValue("deal_package_id", editPackageId, false);

            // formik.setFieldValue(
            //   "deal_package",
            //   CustomerData?.deal_package || metas?.deal_package_name || "",
            //   false
            // );
          }
        } else if (!editSubId && editPackageId) {
          const existsPkg = packages.some(
            (pk) => Number(pk.packageid) === Number(editPackageId)
          );
          if (!existsPkg) {
            setPackages((prev) => {
              const merged = [
                ...prev,
                {
                  packageid: editPackageId,
                  packagename: metas?.packagename,
                },
              ];

              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) => Number(t.packageid) === Number(v.packageid)
                  ) === i
              );
              return unique;
            });
          }
          // formik.setFieldValue("deal_package_id", editPackageId, false);
        }
      } catch (err) {}
    };

    if (CustomerData) {
      runPrefill();
    }

    return () => {
      mounted = false;
    };
  }, [CustomerData]);

  const selectedMainOption =
    mainOptions.find(
      (o) => Number(o.value) === Number(formik.values.main_product)
    ) || null;
  const selectedSubOption =
    subOptions.find((o) => Number(o.value) === Number(formik.values.product)) ||
    null;
  const selectedPackageOption =
    packageOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_package)
    ) || null;

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head}`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>
            {CustomerData?.leadid
              ? "Update Details"
              : CustomerData?.userid
              ? "Update Details"
              : "Add Lead"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div> */}

        <div className={Style.modal_body}>
          {CustomerData?.leadid || CustomerData?.userid ? (
            <FormArea>
              {/* Name */}
              <FeildWraper width="100%">
                <FormLabel required>Name</FormLabel>
                <input
                  name="customerFullName"
                  value={formik.values.customerFullName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter Name"
                />
                {formik.touched.customerFullName &&
                  formik.errors.customerFullName && (
                    <FeildError>{formik.errors.customerFullName}</FeildError>
                  )}
              </FeildWraper>

              {/* Email */}

              <FeildWraper width="100%">
                <FormLabel required>Email</FormLabel>
                <input
                  name="customerEmailAddress"
                  value={formik.values.customerEmailAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="email"
                  placeholder="Enter Email"
                />
                {formik.touched.customerEmailAddress &&
                  formik.errors.customerEmailAddress && (
                    <FeildError>
                      {formik.errors.customerEmailAddress}
                    </FeildError>
                  )}
              </FeildWraper>

              {/* Phone */}

              <FeildWraper width="100%">
                <FormLabel required>Phone</FormLabel>
                <input
                  name="phone"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter Phone"
                />
                {formik.touched.phone && formik.errors.phone && (
                  <FeildError>{formik.errors.phone}</FeildError>
                )}
              </FeildWraper>

              {/* Country */}

              <FeildWraper width="100%">
                <FormLabel required>Country</FormLabel>
                <Select
                  name="country"
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={countryOptions}
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  value={countryOptions.find(
                    (option) => option.label === formik.values.country
                  )}
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "country",
                      selectedOption?.label || ""
                    );
                  }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  placeholder="Search or select country..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({ ...base, padding: 0 }),
                    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                  }}
                />
                {formik.touched.country && formik.errors.country && (
                  <FeildError>{formik.errors.country}</FeildError>
                )}
              </FeildWraper>

              {/* Assigned */}

              <FeildWraper width="100%">
                <FormLabel required>Assigned</FormLabel>
                {/* <SelectSearch
                  menuPosition="fixed"
                  name="lead_assigned"
                  placeholder="- Select Assigned -"
                 
                  onChange={(selectedOption) => {
                    const ids = selectedOption?.map((opt) => opt.value);
                    formik.setFieldValue("lead_assigned", ids);
                  }}
                  value={formik.values.lead_assigned}
                  options={userOptions}
                /> */}

                <Select
                  name="lead_assigned"
                  isMulti
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={userOptions}
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  value={userOptions.filter((option) =>
                    Array.isArray(formik.values.lead_assigned)
                      ? formik.values.lead_assigned.includes(option.value)
                      : false
                  )}
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions?.map((opt) => opt.value);
                    formik.setFieldValue("lead_assigned", ids);
                  }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  placeholder="Search or select users..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                      flexWrap: "wrap",
                      gap: "4px",
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: "#E5E7EB",
                      borderRadius: "3px",
                      padding: "2px 6px",
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#666",
                      ":hover": { backgroundColor: "#D1D5DB", color: "#000" },
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                  }}
                />
                {formik.touched.lead_assigned &&
                  formik.errors.lead_assigned && (
                    <FeildError>{formik.errors.lead_assigned}</FeildError>
                  )}
              </FeildWraper>

              {/* Brand */}

              <FeildWraper width="100%">
                <FormLabel required>Brand</FormLabel>
                {/* <SelectSearch
                  menuPosition="fixed"
                  name="brandid"
                  placeholder="- Select Brand -"
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "brandid",
                      selectedOption?.value || ""
                    );
                    handleLeadSource(selectedOption.value);
                  }}
                  value={formik.values.brandid}
                  options={brandOptions}
                /> */}

                <Select
                  name="brandid"
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={brandOptions}
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  value={brandOptions?.find(
                    (option) => option.value === formik.values.brandid
                  )}
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "brandid",
                      selectedOption?.value || ""
                    );
                    handleLeadSource(selectedOption?.value);
                  }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  placeholder="Search or select Brands..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({ ...base, padding: 0 }),
                    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                  }}
                />
                {formik.touched.brandid && formik.errors.brandid && (
                  <FeildError>{formik.errors.brandid}</FeildError>
                )}
              </FeildWraper>

              {/* Main Product */}

              <FeildWraper width="100%">
                <FormLabel required>Product</FormLabel>
                <Select
                  className="text-sm"
                  classNamePrefix="react-select"
                  value={selectedMainOption}
                  onChange={handleMainSelect}
                  options={mainOptions}
                  isLoading={loadingMain}
                  isClearable
                  placeholder="Select main product..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({ ...base, padding: 0 }),
                    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                  }}
                />
                {formik.touched.main_product && formik.errors.main_product && (
                  <FeildError>{formik.errors.main_product}</FeildError>
                )}
              </FeildWraper>

              {/* Sub product */}

              <FeildWraper width="100%">
                <FormLabel required>Sub Product</FormLabel>
                <Select
                  value={
                    subOptions.find(
                      (option) => option.value == formik.values.product
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "product",
                      selectedOption ? selectedOption.value : ""
                    );
                    handleSubSelect(selectedOption); // if you have custom logic
                  }}
                  options={subOptions}
                  isLoading={loadingSub}
                  isClearable
                  placeholder="Select sub product..."
                  classNamePrefix="react-select"
                  className="text-sm"
                  menuPortalTarget={document.body}
                  noOptionsMessage={() =>
                    formik.values.main_product
                      ? "No sub-products"
                      : "Select main product first"
                  }
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({ ...base, padding: 0 }),
                    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                  }}
                />
                {formik.touched.product && formik.errors.product && (
                  <FeildError>{formik.errors.product}</FeildError>
                )}
              </FeildWraper>

              {/* Message */}

              {CustomerData?.leadid ? (
                <FeildWraper width="100%">
                  <FormLabel required>Message</FormLabel>
                  <input
                    name="Message"
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter Message"
                  />
                  {formik.touched.message && formik.errors.message && (
                    <FeildError>{formik.errors.message}</FeildError>
                  )}
                </FeildWraper>
              ) : null}

              {/* Industry */}

              <FeildWraper width="100%">
                <FormLabel required>Industry</FormLabel>
                <input
                  name="industry"
                  value={formik.values.industry}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter Industry"
                />
                {formik.touched.industry && formik.errors.industry && (
                  <FeildError>{formik.errors.industry}</FeildError>
                )}
              </FeildWraper>

              {/* Optional Fields */}

              <FeildWraper>
                <FormLabel>Address</FormLabel>
                <input
                  name="address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter Address"
                />
              </FeildWraper>

              <FeildWraper>
                <FormLabel>City</FormLabel>
                <input
                  name="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter City"
                />
              </FeildWraper>

              <FeildWraper>
                <FormLabel>State</FormLabel>
                <input
                  name="state"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter State"
                />
              </FeildWraper>

              <FeildWraper>
                <FormLabel>Company name</FormLabel>
                <input
                  name="company_name"
                  value={formik.values.company_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="text"
                  placeholder="Enter Company name"
                />
              </FeildWraper>

              <FormLineBreak />

              {Array.isArray(formik.values.extra_meta) &&
                formik.values.extra_meta.some(
                  (field) => !primaryFields.includes(field.meta_key)
                ) && (
                  <div className="flex items-center pt-3 px-2">
                    <h1 className="text-md font-medium  py-1">
                      Additional Fields
                    </h1>
                  </div>
                )}

              {/* Extra Meta */}

              {/* <div className="flex flex-wrap justify-between  gap-2">
                

                {formik.values.extra_meta.map((field, index) => {
                  if (primaryFields?.includes(field.meta_key)) {
                    return null; // Skip rendering if it's a primary field
                  }

                  return (
                    <div
                      className={`${Style.dcmb__cardBody_formmeta}`}
                      key={index}
                    >
                      <div
                        className={`${Style["dcmb__cardBody_formArea_feild"]}`}
                      >
                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_key`}
                          value={formik.values.extra_meta[index].meta_key}
                          onChange={formik.handleChange}
                          placeholder="key"
                        />
                      </div>
                      <div
                        className={`${Style["dcmb__cardBody_formArea_feild"]}`}
                      >
                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_value`}
                          value={formik.values.extra_meta[index].meta_value}
                          onChange={formik.handleChange}
                          placeholder="value"
                        />
                      </div>
                      <Tooltip
                        key={`${index}-asideBottomItems`}
                        className={`${Style.Tooltip}`}
                        boxClassName={Style.TooltipBox}
                        content="Delete Field"
                        position={"bottom center"}
                      >
                        <div
                          onClick={() => DeleteField(index)}
                          className="p-3 text-red-600"
                        >
                          <Trash2 size={18} />
                        </div>
                      </Tooltip>
                    </div>
                  );
                })}

                <button
                  type="button"
                  onClick={AddField}
                  className="flex flex-start text-blue-700 font-medium "
                >
                  + Add Field
                </button>



              
              </div> */}

              <FeildWraper width="100%">
                {formik?.values?.extra_meta.map((field, index) => {
                  if (primaryFields?.includes(field.meta_key)) {
                    return null; // Skip rendering if it's a primary field
                  }

                  return (
                    <div className={`w-full flex gap-3`} key={index}>
                      {/* key */}

                      <input
                        type="text"
                        name={`extra_meta[${index}].meta_key`}
                        value={formik.values.extra_meta[index].meta_key}
                        onChange={formik.handleChange}
                        placeholder="key"
                      />

                      {/* value */}

                      <input
                        type="text"
                        name={`extra_meta[${index}].meta_value`}
                        value={formik.values.extra_meta[index].meta_value}
                        onChange={formik.handleChange}
                        placeholder="value"
                      />

                      <Tooltip
                        key={`${index}-asideBottomItems`}
                        className={`${Style.Tooltip}`}
                        boxClassName={Style.TooltipBox}
                        content="Delete Field"
                        position={"bottom center"}
                      >
                        <div
                          onClick={() => DeleteField(index)}
                          className="p-3 text-red-600"
                        >
                          <Trash2 size={18} />
                        </div>
                      </Tooltip>
                    </div>
                  );
                })}

                <button
                  type="button"
                  onClick={AddField}
                  className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                >
                  + Add Field
                </button>
              </FeildWraper>
            </FormArea>
          ) : (
            <div>
              <FormArea>
                {/* Name */}
                <FeildWraper>
                  <FormLabel required>Name</FormLabel>
                  <input
                    name="customerFullName"
                    value={formik.values.customerFullName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter Name"
                  />
                  {formik.touched.customerFullName &&
                    formik.errors.customerFullName && (
                      <FeildError>{formik.errors.customerFullName}</FeildError>
                    )}
                </FeildWraper>

                {/* Email */}

                <FeildWraper>
                  <FormLabel required>Email</FormLabel>
                  <input
                    name="customerEmailAddress"
                    value={formik.values.customerEmailAddress}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="email"
                    placeholder="Enter Email"
                  />
                  {formik.touched.customerEmailAddress &&
                    formik.errors.customerEmailAddress && (
                      <FeildError>
                        {formik.errors.customerEmailAddress}
                      </FeildError>
                    )}
                </FeildWraper>

                {/* Phone */}

                <FeildWraper>
                  <FormLabel required>Phone</FormLabel>
                  <input
                    name="phone"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter Phone"
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <FeildError>{formik.errors.phone}</FeildError>
                  )}
                </FeildWraper>

                {/* Country */}

                <FeildWraper>
                  <FormLabel required>Country</FormLabel>
                  <Select
                    name="country"
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={countryOptions}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={countryOptions.find(
                      (option) => option.label === formik.values.country
                    )}
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "country",
                        selectedOption?.label || ""
                      );
                    }}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    placeholder="Search or select country..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({ ...base, padding: 0 }),
                      dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                  />
                  {formik.touched.country && formik.errors.country && (
                    <FeildError>{formik.errors.country}</FeildError>
                  )}
                </FeildWraper>

                {/* Assigned */}

                <FeildWraper>
                  <FormLabel required>Assigned</FormLabel>
                  {/* <SelectSearch
                    menuPosition="fixed"
                    name="lead_assigned"
                    placeholder="- Select Assigned -"
                    onChange={(selectedOption) => {
                      const ids = selectedOption?.map((opt) => opt.value);
                      formik.setFieldValue("lead_assigned", ids);
                    }}
                    value={formik.values.lead_assigned}
                    options={userOptions}
                  /> */}

                  <Select
                    name="lead_assigned"
                    isMulti
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={userOptions}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={userOptions.filter((option) =>
                      Array.isArray(formik.values.lead_assigned)
                        ? formik.values.lead_assigned.includes(option.value)
                        : false
                    )}
                    onChange={(selectedOptions) => {
                      const ids = selectedOptions.map((opt) => opt.value);
                      formik.setFieldValue("lead_assigned", ids);
                    }}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    placeholder="Search or select users..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                        flexWrap: "wrap",
                        gap: "4px",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#E5E7EB",
                        borderRadius: "3px",
                        padding: "2px 6px",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#666",
                        ":hover": { backgroundColor: "#D1D5DB", color: "#000" },
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                    }}
                  />
                  {formik.touched.lead_assigned &&
                    formik.errors.lead_assigned && (
                      <FeildError>{formik.errors.lead_assigned}</FeildError>
                    )}
                </FeildWraper>

                {/* Brand */}

                <FeildWraper>
                  <FormLabel required>Brand</FormLabel>
                  {/* <SelectSearch
                    menuPosition="fixed"
                    name="brandid"
                    placeholder="- Select Brand -"
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "brandid",
                        selectedOption?.value || ""
                      );
                      handleLeadSource(selectedOption.value);
                    }}
                    value={formik.values.brandid}
                    options={brandOptions}
                  /> */}
                  <Select
                    name="brandid"
                    className="text-sm"
                    classNamePrefix="react-select"
                    options={brandOptions}
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    value={brandOptions?.find(
                      (option) => option.value === formik.values.brandid
                    )}
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "brandid",
                        selectedOption?.value || ""
                      );
                      handleLeadSource(selectedOption?.value);
                    }}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    placeholder="Search or select Brands..."
                    isClearable
                    menuPlacement="auto"
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({ ...base, padding: 0 }),
                      dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                  />
                  {formik.touched.brandid && formik.errors.brandid && (
                    <FeildError>{formik.errors.brandid}</FeildError>
                  )}
                </FeildWraper>

                {/* Main Product */}

                <FeildWraper>
                  <FormLabel required>Product</FormLabel>
                  <Select
                    className="text-sm"
                    classNamePrefix="react-select"
                    value={selectedMainOption}
                    onChange={handleMainSelect}
                    options={mainOptions}
                    isLoading={loadingMain}
                    isClearable
                    placeholder="Select main product..."
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({ ...base, padding: 0 }),
                      dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                  />
                  {formik.touched.main_product &&
                    formik.errors.main_product && (
                      <FeildError>{formik.errors.main_product}</FeildError>
                    )}
                </FeildWraper>

                {/* Sub product */}

                <FeildWraper>
                  <FormLabel required>Sub Product</FormLabel>
                  <Select
                    value={
                      subOptions.find(
                        (option) => option.value == formik.values.product
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "product",
                        selectedOption ? selectedOption.value : ""
                      );
                      handleSubSelect(selectedOption); // if you have custom logic
                    }}
                    options={subOptions}
                    isLoading={loadingSub}
                    isClearable
                    placeholder="Select sub product..."
                    classNamePrefix="react-select"
                    className="text-sm"
                    menuPortalTarget={document.body}
                    noOptionsMessage={() =>
                      formik.values.main_product
                        ? "No sub-products"
                        : "Select main product first"
                    }
                    menuPosition="fixed"
                    components={{
                      IndicatorSeparator: () => null,
                      LoadingIndicator: () => null,
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "35px",
                        height: "auto",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": { borderColor: "#DFDFDF" },
                        fontSize: "13px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        padding: "0 14px",
                        cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "auto",
                        padding: "0 0px 0",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                        height: "auto",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#1E1E1E",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: "#717680",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "5px",
                        border: "1px solid #DFDFDF",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        lineHeight: "1.2",
                        fontWeight: 500,
                        color: state.isSelected ? "#FFF" : "#1E1E1E",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                          ? "#F3F4F6"
                          : "#FFF",
                        padding: "8px 14px",
                        cursor: "pointer",
                      }),
                      indicatorContainer: (base) => ({ ...base, padding: 0 }),
                      dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                    }}
                  />
                  {formik.touched.product && formik.errors.product && (
                    <FeildError>{formik.errors.product}</FeildError>
                  )}
                </FeildWraper>

                {/* Message */}

                {CustomerData?.leadid ? (
                  <FeildWraper>
                    <FormLabel required>Message</FormLabel>
                    <input
                      name="Message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Message"
                    />
                    {formik.touched.message && formik.errors.message && (
                      <FeildError>{formik.errors.message}</FeildError>
                    )}
                  </FeildWraper>
                ) : null}

                {/* Industry */}

                <FeildWraper>
                  <FormLabel required>Industry</FormLabel>
                  <input
                    name="industry"
                    value={formik.values.industry}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter Industry"
                  />
                  {formik.touched.industry && formik.errors.industry && (
                    <FeildError>{formik.errors.industry}</FeildError>
                  )}
                </FeildWraper>

                {/* Message */}

                <FeildWraper>
                  <FormLabel required>Message</FormLabel>
                  <input
                    name="message"
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter Message"
                  />
                  {formik.touched.message && formik.errors.message && (
                    <FeildError>{formik.errors.message}</FeildError>
                  )}
                </FeildWraper>

                <div
                  onClick={() => setShowAdditionalFiels(!showAdditionalFiels)}
                  className="flex items-center justify-between cursor-pointer mt-6 mb-3  px-3 w-full "
                >
                  <span className="text-black text-[16px] font-semibold leading-[1.25] ">
                    Additional Details
                  </span>

                  <div
                    className={`w-7 h-7 flex items-center justify-center rounded-full border
                    transition-all duration-300 bg-[#335CFF] text-white text-xl font-bold
                    ${showAdditionalFiels ? " bg-red-500" : ""}`}
                  >
                    {showAdditionalFiels ? <Minus /> : <PlusIcon />}
                  </div>
                </div>

                {showAdditionalFiels && (
                  <>
                    {/* Additional Fields */}

                    <FormArea className="px-3">
                      <FeildWraper>
                        <FormLabel>Match Type</FormLabel>
                        <input
                          type="text"
                          name="matchtype"
                          value={formik.values.matchtype}
                          onChange={formik.handleChange}
                          placeholder="Match Type"
                        />
                      </FeildWraper>

                      <FeildWraper>
                        <FormLabel>Device</FormLabel>
                        <input
                          type="text"
                          name="device"
                          value={formik.values.device}
                          onChange={formik.handleChange}
                          placeholder="Device"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Keyword</FormLabel>
                        <input
                          type="text"
                          name="keyword"
                          value={formik.values.keyword}
                          onChange={formik.handleChange}
                          placeholder="Keyword"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>UTM Term</FormLabel>
                        <input
                          type="text"
                          name="utm_term"
                          value={formik.values.utm_term}
                          onChange={formik.handleChange}
                          placeholder="UTM Term"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Gclid</FormLabel>
                        <input
                          type="text"
                          name="gclid"
                          value={formik.values.gclid}
                          onChange={formik.handleChange}
                          placeholder="Gclid"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Msclkid</FormLabel>
                        <input
                          type="text"
                          name="msclkid"
                          value={formik.values.msclkid}
                          onChange={formik.handleChange}
                          placeholder="Msclkid"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Ip</FormLabel>
                        <input
                          type="text"
                          name="ip"
                          value={formik.values.ip}
                          onChange={formik.handleChange}
                          placeholder="Ip"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Address Line 1</FormLabel>
                        <input
                          type="text"
                          name="address"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          placeholder="Address line 1"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Address line 2</FormLabel>
                        <input
                          type="text"
                          name="address_line_2"
                          value={formik.values.address_line_2}
                          onChange={formik.handleChange}
                          placeholder="Address line 2"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>City</FormLabel>
                        <input
                          type="text"
                          name="city"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          placeholder="City"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>State</FormLabel>
                        <input
                          type="text"
                          name="state"
                          value={formik.values.state}
                          onChange={formik.handleChange}
                          placeholder="State"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Zip</FormLabel>
                        <input
                          type="text"
                          name="zip"
                          value={formik.values.zip}
                          onChange={formik.handleChange}
                          placeholder="Zip"
                        />
                      </FeildWraper>
                      <FeildWraper>
                        <FormLabel>Company name</FormLabel>
                        <input
                          type="text"
                          name="company_name"
                          value={formik.values.company_name}
                          onChange={formik.handleChange}
                          placeholder="Company Name"
                        />
                      </FeildWraper>

                      {/*  Add more */}

                      <FeildWraper width="100%">
                        {formik?.values?.extra_meta.map((field, index) => (
                          <div className={`w-full flex gap-3`} key={index}>
                            {/* key */}

                            <input
                              type="text"
                              name={`extra_meta[${index}].meta_key`}
                              value={formik.values.extra_meta[index].meta_key}
                              onChange={formik.handleChange}
                              placeholder="key"
                            />

                            {/* value */}

                            <input
                              type="text"
                              name={`extra_meta[${index}].meta_value`}
                              value={formik.values.extra_meta[index].meta_value}
                              onChange={formik.handleChange}
                              placeholder="value"
                            />

                            <Tooltip
                              key={`${index}-asideBottomItems`}
                              className={`${Style.Tooltip}`}
                              boxClassName={Style.TooltipBox}
                              content="Delete Field"
                              position={"bottom center"}
                            >
                              <div
                                onClick={() => DeleteField(index)}
                                className="p-3 text-red-600"
                              >
                                <Trash2 size={18} />
                              </div>
                            </Tooltip>
                          </div>
                        ))}

                        <button
                          type="button"
                          onClick={AddField}
                          className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                        >
                          + Add Field
                        </button>
                      </FeildWraper>
                    </FormArea>
                  </>
                )}

                <FormLineBreak />
              </FormArea>

              {/* <h3 className="text-black text-[16px] font-semibold leading-[1.25] w-full py-[25px]">
                Additional Details
              </h3> */}

              <div
                onClick={() => setShowDealFields(!showDealFields)}
                className="flex items-center justify-between cursor-pointer mt-6 mb-3  w-full px-[2px] "
              >
                <span className="text-black text-[16px] font-semibold leading-[1.25] ">
                  Add Deal
                </span>

                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full border
    transition-all duration-300 bg-[#335CFF] text-white text-xl font-bold 
    ${showDealFields ? " bg-red-500" : ""}`}
                >
                  {showDealFields ? <Minus /> : <PlusIcon />}
                </div>
              </div>

              {showDealFields && (
                <>
                  <FormArea>
                    {/* Deal Name */}

                    <FeildWraper>
                      <FormLabel>Deal Name</FormLabel>
                      <input
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="text"
                        placeholder="Enter Name"
                      />
                      {formik.touched.name && formik.errors.name && (
                        <FeildError>{formik.errors.name}</FeildError>
                      )}
                    </FeildWraper>
                    {/* Description */}
                    <FeildWraper>
                      <FormLabel>Description</FormLabel>
                      <input
                        name="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="text"
                        placeholder="Enter Description"
                      />
                      {formik.touched.description &&
                        formik.errors.description && (
                          <FeildError>{formik.errors.description}</FeildError>
                        )}
                    </FeildWraper>

                    {/* Estimated Amount Date */}
                    <FeildWraper>
                      <FormLabel>Estimated Date</FormLabel>
                      <input
                        name="estimated_payment_date"
                        value={formik.values.estimated_payment_date}
                        onChange={formik.handleChange}
                        min={new Date().toISOString().split("T")[0]}
                        onBlur={formik.handleBlur}
                        type="date"
                        placeholder="Enter Payment Date"
                      />
                      {formik.touched.estimated_payment_date &&
                        formik.errors.estimated_payment_date && (
                          <FeildError>
                            {formik.errors.estimated_payment_date}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Deal Amount */}
                    <FeildWraper>
                      <FormLabel>Deal Amount</FormLabel>
                      <input
                        name="dealamount"
                        value={formik.values.dealamount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="number"
                        placeholder="Enter Amount"
                      />
                      {formik.touched.dealamount &&
                        formik.errors.dealamount && (
                          <FeildError>{formik.errors.dealamount}</FeildError>
                        )}
                    </FeildWraper>

                    {/* Deal probability */}
                    <FeildWraper>
                      <FormLabel>Probability</FormLabel>

                      <select
                        name="dealprobability"
                        value={formik.values.dealprobability}
                        onChange={formik.handleChange}
                      >
                        <option value="" disabled>
                          -- Select Probability --
                        </option>

                        {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                          (num, i) => (
                            <option value={num} key={i}>
                              {num}
                            </option>
                          )
                        )}
                      </select>
                      {formik.touched.dealprobability &&
                        formik.errors.dealprobability && (
                          <FeildError>
                            {formik.errors.dealprobability}
                          </FeildError>
                        )}
                    </FeildWraper>

                    {/* Pipeline stage */}
                    <FeildWraper className="!max-w-md">
                      <FormLabel>Pipeline stage</FormLabel>
                      <div className="flex  overflow-hidden h-8">
                        {DealStages.map((stage, index) => {
                          // const isActive = index === CurrentStage;
                          const isFirst = index === 0;
                          const isLast = index === TotalStages - 1;

                          //  Set clip-path based on position
                          let clipPath = "";
                          if (isFirst) {
                            clipPath = `
                      polygon(
                        0 0,
                        calc(100% - 10px) 0,
                        100% 50%,
                        calc(100% - 10px) 100%,
                        0 100%
                      )
                        
                    `;
                          } else if (isLast) {
                            clipPath = `
                    polygon(
                      0 0,
                      10px 50%,
                      0 100%,
                      100% 100%,
                      100% 0
                    )
                  `;
                          } else {
                            clipPath = `
                      polygon(
                        0 0,
                        10px 50%,
                        0 100%,
                        calc(100% - 10px) 100%,
                        100% 50%,
                        calc(100% - 10px) 0
                      )
                    `;
                          }

                          return (
                            <Tooltip
                              key={`${index}-asideBottomItems`}
                              className={`${Style.Tooltip}`}
                              boxClassName={Style.TooltipBox}
                              content={stage?.name}
                              position={"bottom center"}
                            >
                              <div
                                key={index}
                                onClick={() => {
                                  handleStageClick(stage.id);
                                }}
                                className={`
                            min-h-[27px] min-w-[60px]  flex-1 
                          ${
                            stage.id <= CurrentStage
                              ? "bg-[#2563eb]"
                              : "bg-gray-200"
                          }
                          ${
                            isFirst
                              ? `rounded-tl-md rounded-bl-md`
                              : isLast
                              ? "rounded-tr-md rounded-br-md"
                              : null
                          }
                        `}
                                style={{
                                  clipPath: clipPath,
                                  WebkitClipPath: clipPath,
                                }}
                              />
                            </Tooltip>
                          );
                        })}
                      </div>
                    </FeildWraper>

                    {/* Deal Package */}

                    <FeildWraper>
                      <FormLabel>Package</FormLabel>

                      <Select
                        value={selectedPackageOption}
                        onChange={handlePackageSelect}
                        options={packageOptions}
                        isLoading={loadingPackages}
                        // menuPortalTarget={document.body}
                        // menuPosition="fixed"
                        isClearable
                        placeholder="Select package..."
                        classNamePrefix="react-select"
                        className="text-sm"
                        menuPortalTarget={document.body}
                        noOptionsMessage={() =>
                          formik.values.deal_product
                            ? "No packages"
                            : "Select sub product first"
                        }
                        components={{
                          IndicatorSeparator: () => null,
                          LoadingIndicator: () => null,
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: "35px",
                            height: "auto",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            backgroundColor: state.isDisabled
                              ? "#f0f0f0"
                              : "#FFF",
                            boxShadow: state.isFocused ? "none" : "none",
                            "&:hover": { borderColor: "#DFDFDF" },
                            fontSize: "13px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            padding: "0 14px",
                            cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "auto",
                            padding: "0 0px 0",
                          }),
                          input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                            height: "auto",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#1E1E1E",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: "#717680",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                          }),
                          menu: (base) => ({
                            ...base,
                            marginTop: "2px",
                            borderRadius: "5px",
                            border: "1px solid #DFDFDF",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }),
                          option: (base, state) => ({
                            ...base,
                            fontSize: "14px",
                            lineHeight: "1.2",
                            fontWeight: 500,
                            color: state.isSelected ? "#FFF" : "#1E1E1E",
                            backgroundColor: state.isSelected
                              ? "#3b82f6"
                              : state.isFocused
                              ? "#F3F4F6"
                              : "#FFF",
                            padding: "8px 14px",
                            cursor: "pointer",
                          }),
                          indicatorContainer: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: 0,
                          }),
                        }}
                      />
                    </FeildWraper>

                    {/* Features */}
                    <FeildWraper>
                      <FormLabel>Features</FormLabel>
                      <textarea
                        name="features"
                        value={formik.values.features}
                        onChange={formik.handleChange}
                        rows={6}
                        placeholder="Write or edit package features here..."
                      />
                    </FeildWraper>
                  </FormArea>
                </>
              )}
            </div>
          )}
        </div>

        <div className={Style.modal_foot}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={`${Style.dcmb__submit}`}>
            {CustomerData?.leadid || CustomerData?.userid
              ? "Save Changes"
              : "Create Lead"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddLeadModal;
